module.exports = __webpack_public_path__ + "static/CareLabel-v1-no-border-2200f6ba37fd5b406b41fc5651535767.svg";